import { PageWrapper, useLayout } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { hocs as pageHocs } from 'modules/page';
import { memo } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { useGetStarterGuideOrganisationSteps } from 'shared/data/myAccount/v2';
import { useExpandedCompany } from 'shared/hooks/useExpandedCompany';
import { activeCompanyIdState, starterGuideCompaniesState } from 'shared/states';
import { getDefaultPath } from 'urlBuilder';

import { Loading } from './loading';
import { GettingStarted } from './resources/components/GettingStarted/GettingStarted';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { messages } from './resources/messages';
import { ContentProps } from './resources/types';

const Content = memo<ContentProps>((props) => {
    const { company } = props;

    useLayout({ hasHeader: true, hasDrawer: true });
    useBreadcrumbs();

    const { isLoading, data } = useGetStarterGuideOrganisationSteps({
        path: { organisationId: company.id, OrganisationId: company.id } as any, // TODO wait fix in swagger
    });

    return (
        <PageWrapper>
            <Helmet title={messages.title} />

            <PageWrapper.Content>
                {isLoading ? (
                    <Loading />
                ) : (
                    <GettingStarted
                        companyId={company.id}
                        integrationType={company?.integration?.integrationType}
                        companyDisplayName={company.displayName}
                        steps={data?.steps ?? []}
                    />
                )}
            </PageWrapper.Content>
        </PageWrapper>
    );
});

const Page = memo(() => {
    const companyId = useAtomValue(activeCompanyIdState);
    const starterGuideCompanies = useAtomValue(starterGuideCompaniesState);

    const company = useExpandedCompany(companyId);

    if (!company || !starterGuideCompanies.includes(company.id)) {
        return <Redirect to={getDefaultPath()} />;
    }

    return <Content company={company} />;
});

Page.displayName = 'Page';

export default pageHocs.withProtected({ Page });
